export const INPUT_PROMO_STAGS = [
  '90727',
  '91907',
  '93426',
  '101789',
  '96038',
  '106349',
  '96021',
  '111473',
  '95484',
  '122798',
  '107255',
  '93377',
  '150421',
  '150261',
  '92763',
  '143868',
  '93426',
  '102127',
  '101552',
  '149685',
  '149125',
  '90514',
  '106349',
  '108435',
  '110987',
  '110989',
  '100554',
  '111473',
  '126994',
  '129178',
  '95853',
  '92193',
  '92515',
  '103172',
  '93406',
  '104399',
  '108344',
  '93525',
  '135913',
  '98248',
  '92193',
  '93443',
  '92757',
  '103098',
  '97921',
  '122561',
  '117010',
  '103354',
  '99649',
  '132694',
  '130344',
  '95350',
  '211822',
  '154574',
  '96836',
  '95690',
  '103172',
  '153473',
  '92193',
  '121744',
  '91332',
  '133949',
  '132397',
  '111363',
  '140571',
  '138772',
  '91714',
  '91311',
  '170820',
  '105424',
  '100674',
  '110219',
  '93161',
  '140916',
  '124143',
  '129674',
  '137553',
  '117252',
  '100674',
  '90949',
  '90949',
  '90949',
  '95350',
  '212238',
  '212236',
  '151644',
  '118092',
  '90514',
  '158099',
  '118092',
  '95690',
  '152997',
  '93032',
  '140916',
  '95350',
  '90949',
  '143327',
  '95350',
  '92193',
  '92193',
  '101555',
  '208366',
  '154709',
  '212627',
];
